import {Stack, List, ListItemIcon, ListItemText, ListItem} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import multidayChildTrips from "../trips/multidayChildTrips";
import {TripCollection} from "../trips/Trip";
import childDayTrips from "../trips/childDay/childDayTrips";
import TripCollectionComponent from "../trips/TripCollectionComponent";
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';

const Child = () => {
    return (
        <Stack direction="column" padding="40px" gap="40px">
            {/*common details*/}
            <Stack direction="column">
                <Typography variant="h4">
                    Pachetele includ
                </Typography>
                <List>
                    <ListItem key="0">
                        <ListItemIcon>
                            <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="Excursii și programe educaționale pentru elevi"/>
                    </ListItem>
                    <ListItem key="1">
                        <ListItemIcon>
                            <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="Transport cu autocar/microbuz clasificat pentru turism"/>
                    </ListItem>
                    <ListItem key="2">
                        <ListItemIcon>
                            <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="Ghid însoţitor pe întreg parcursul excursiei"/>
                    </ListItem>
                    <ListItem key="3">
                        <ListItemIcon>
                            <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="Taxele de intrare la obiectivele turistice prevăzute în program"/>
                    </ListItem>
                    <ListItem key="4">
                        <ListItemIcon>
                            <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="Asistenţă pentru întocmirea dosarului necesar excursiei"/>
                    </ListItem>
                    <ListItem key="5">
                        <ListItemIcon>
                            <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="Preluarea grupului din vecinătatea şcolii sau din locuri stabilite"/>
                    </ListItem>
                    {/*<*/}
                    <ListItem key="6">
                        <ListItemIcon>
                            <AddIcon sx={{color: 'primary.contrastText'}}/>
                        </ListItemIcon>
                        <ListItemText
                            primary="SUPLIMENTAR se poate solicita servirea mesei într-unul din restaurantele partenere"/>
                    </ListItem>
                </List>

                <Typography variant="h6">
                    Nu ai găsit o excursie potrivită?
                </Typography>
                <Typography variant="h6">
                    Nu este nicio problemă, solicită personalizarea uneia,
                    conform dorinţelor tale.
                </Typography>
            </Stack>

            {/*Excursii de o zi*/}
            <Stack direction={{xs: 'column', md: 'row'}} gap="20px" justifyContent="center">
                <Stack direction="column" gap="20px">
                    <Typography variant="h4" alignSelf="center">
                        Excursii de o zi
                    </Typography>
                    <Stack direction="column" gap="40px">
                        {childDayTrips.map((tripCollection: TripCollection, collectionIndex) =>
                            <TripCollectionComponent tripCollection={tripCollection} index={collectionIndex}/>
                        )}
                    </Stack>
                </Stack>
            </Stack>

            {/*Excursii de 2-3-4 zile*/}
            <Stack direction={{xs: 'column', md: 'row'}} gap="20px" justifyContent="center">
                <Stack direction="column" gap="20px">
                    <Typography variant="h4" alignSelf="center">
                        Excursii de 2-3-4 zile
                    </Typography>
                    <TripCollectionComponent tripCollection={multidayChildTrips} index={1}/>
                </Stack>
            </Stack>

            {/*/!*Excursii Externe*!/*/}
            {/*<Stack direction={{xs: 'column', md: 'row'}} gap="20px" justifyContent="center">*/}
            {/*    <Stack direction="column" gap="20px">*/}
            {/*        <Typography variant="h4" alignSelf="center">*/}
            {/*            Excursii Externe*/}
            {/*        </Typography>*/}
            {/*        <List>*/}
            {/*            /!*to add new object*!/*/}
            {/*            {campChildTrips.map((trip) => <TripListItem trip={trip}/>)}*/}
            {/*        </List>*/}
            {/*    </Stack>*/}
            {/*    /!*<StyledPageImage src={c3} alt="excursie"/>*!/*/}
            {/*</Stack>*/}

            {/*/!*Tabere*!/*/}
            {/*<Stack direction={{xs: 'column', md: 'row'}} gap="20px" justifyContent="center">*/}
            {/*    <Stack direction="column" gap="20px">*/}
            {/*        <Typography variant="h4" alignSelf="center">*/}
            {/*            Tabere*/}
            {/*        </Typography>*/}
            {/*        <List>*/}
            {/*            {campChildTrips.map((trip) => <TripListItem trip={trip}/>)}*/}
            {/*        </List>*/}
            {/*    </Stack>*/}
            {/*    /!*<StyledPageImage src={c3} alt="excursie"/>*!/*/}
            {/*</Stack>*/}
        </Stack>
    )
}

export default Child;